module.exports = __webpack_public_path__ + "static/media/phone_enlev.f1ed0d71.png";